import axios from "axios";
import constants from "../constants"

export const getItems = async (customerNumber: string, itemNumbers?: string[]) => {
  try {
    let url = `${constants.ONTRAQ_API_URL}/api2/${customerNumber}/items`;
    if(itemNumbers) url = `${url}?ids=${JSON.stringify(itemNumbers)}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};